'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var COLORS = {
    barColor: '#31CC97',
    labelColor: 'black',
};
var HEIGHT = 30;
var BORDER_RADIUS = '6px';

exports.BORDER_RADIUS = BORDER_RADIUS;
exports.COLORS = COLORS;
exports.HEIGHT = HEIGHT;
